import { tokens } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getSkycFormWidgetStyles = props => {
  var _ref = props !== null && props !== void 0 ? props : {},
    variant = _ref.variant;
  var _tokens$spacing = tokens.spacing,
    SPACING_8 = _tokens$spacing.SPACING_8,
    SPACING_16 = _tokens$spacing.SPACING_16,
    SPACING_20 = _tokens$spacing.SPACING_20,
    SPACING_12 = _tokens$spacing.SPACING_12,
    SPACING_0 = _tokens$spacing.SPACING_0,
    SPACING_4 = _tokens$spacing.SPACING_4;
  return StyleSheet.create({
    heading: {
      paddingVertical: SPACING_8
    },
    content: {
      paddingHorizontal: SPACING_16,
      paddingBottom: SPACING_16
    },
    inputWidget: {
      marginBottom: SPACING_16
    },
    aadhaarInput: {
      marginBottom: SPACING_12
    },
    calloutWidget: {
      marginBottom: SPACING_16
    },
    titleComponent: {
      width: '100%',
      marginTop: SPACING_8
    },
    stepCardTitle: {
      width: '100%'
    },
    checkBoxWidget: Object.assign(Object.assign(Object.assign({
      marginBottom: SPACING_20,
      zIndex: -1,
      marginTop: SPACING_12
    }, variant && variant === 'INCOME_DETAILS_VERIFICATION' && {
      marginTop: SPACING_12,
      marginBottom: SPACING_0
    }), variant && variant === 'AADHAAR_VERIFICATION' && {
      marginBottom: SPACING_20,
      marginTop: SPACING_12
    }), variant && variant === 'IDENTITY_PROOF' && {
      marginTop: SPACING_16
    }),
    dateInput: {
      display: 'flex',
      flexDirection: 'row',
      gap: SPACING_8,
      marginBottom: SPACING_16,
      width: '100%',
      zIndex: 1
    },
    label: {
      marginBottom: SPACING_4
    },
    divider: {
      marginTop: SPACING_12,
      marginHorizontal: -SPACING_16,
      width: 'auto'
    },
    buttonWidget: {
      marginTop: SPACING_4
    },
    calloutContainer: {
      marginBottom: SPACING_8,
      marginHorizontal: SPACING_16,
      marginTop: SPACING_8
    }
  });
};